import { useCallback, useState } from 'react'
import { Form, Input, Button, Row, Col, Select, InputNumber } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import styles from './styles.module.scss'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  FURNITURE_TYPE,
  ProductType,
  SECURITY_TYPE,
  status,
  statusList
} from './configs'
import { removeUndefinedValues, removeVietnameseTones } from '../../config-func'
import { labelOptions } from '../../configData'
import { debounce } from 'lodash'
const { Option } = Select

const SearchForm = ({
  form,
  getListPost = () => {},
  listDepartment,
  listProject,
  cities,
  towns,
  districts,
  user,
  onChangePostType,
  listTypeRealEstate = [],
  onChangeCity,
  onChangeDistrict,
  onChangeDepartment,
  setPagination,
  pagination
}) => {
  // const [form] = Form.useForm()
  const [expanded, setExpanded] = useState(false)

  // const handleSearch = (values) => {
  //   const params = removeUndefinedValues(values)
  //   getListPost(params)
  // }

  const handleSearch = useCallback(
    debounce((allValues) => {
      const { acreage,area_outside, ...data } = allValues;
      const params = removeUndefinedValues({
        ...data,
        acreage_min: acreage,
        acreage_max: acreage,
        area_outside_min: area_outside,
        area_outside_max: area_outside,
        page: pagination.current,
        pageSize: pagination.pageSize
      })

      getListPost(params)
    }, 500),
    [pagination.current, pagination.pageSize]
  )

  const handleReset = debounce(() => {
    // setFilters({currentPage: 1,
    // pageSize: 10})
    form.resetFields()
    getListPost()
  }, 300)

  const fields = [
    { label: 'ID', name: 'id', hidden: !expanded },
    { label: 'Tên khách hàng', name: 'customer_name', hidden: !expanded },
    { label: 'Số điện thoại', name: 'customer_phone_number', hidden: !expanded },
    { label: 'Email', name: 'customer_email'},
    { label: 'Người đăng', name: 'user_create' },
    {
      label: 'Tên Sàn',
      name: 'department_id',
      type: 'select',
      arr: listDepartment,
      onChange: onChangeDepartment
    },
    {
      label: 'Quản lý tin',
      name: 'manager_post_id',
      type: 'select',
      arr: user
    },
    {
      label: 'Nhu cầu',
      name: 'label',
      type: 'select',
      arr: labelOptions
    },
    {
      label: 'Loại BĐS',
      name: 'post_type',
      type: 'select',
      arr: ProductType,
      onChange: onChangePostType
    },
    {
      label: 'Loại hình BĐS',
      name: 'type_real_estate',
      type: 'select',
      arr: listTypeRealEstate
    },
    { label: 'Dự án', name: 'project_id', type: 'select', arr: listProject },
    { label: 'Số địa chỉ', name: 'alley' },
    { label: 'Mã căn hộ', name: 'apartment_code' },
    { label: 'Tòa', name: 'building' },
    { label: 'Số tầng', name: 'floor' },
    { label: 'Số căn', name: 'number_of_rooms' },
    { label: 'Số phòng ngủ', name: 'number_of_bedrooms' },
    { label: 'Diện tích (m2)', name: 'acreage' },
    { label: 'Mặt tiền (m)', name: 'area_outside' },
    {
      label: 'Vị trí',
      name: 'apartment_location',
      type: 'select',
      arr: APARTMENT_TYPE
    },
    {
      label: 'Hướng',
      name: 'direction',
      type: 'select',
      arr: BALCONY_DIRECTION
    },
    {
      label: 'Nội thất',
      name: 'furniture',
      type: 'select',
      arr: FURNITURE_TYPE
    },
    {
      label: 'Tỉnh/Thành phố',
      name: 'city_code',
      type: 'select',
      arr: cities,
      onChange: onChangeCity
    },
    {
      label: 'Quận/Huyện',
      name: 'district_code',
      type: 'select',
      arr: districts,
      onChange: onChangeDistrict
    },
    { label: 'Phường/Xã', name: 'town_code', type: 'select', arr: towns },
    { label: 'Đường phố', name: 'street' },
    {
      label: 'Trạng thái tin',
      name: 'post_status',
      type: 'select',
      arr: statusList
    },
    {
      label: 'Bảo mật thông tin',
      name: 'security',
      type: 'select',
      arr: SECURITY_TYPE
    },
    { label: 'Hiện trạng', name: 'status', type: 'select', arr: status },
    // { label: 'Hướng ban công', name: 'balconyDirection', type: 'select' },
    { label: 'Mô tả', name: 'description' },
    { label: 'Note', name: 'note' }
  ]

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      // labelCol={{ span: 8 }}
      // labelAlign="right"
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        if (value.city_code) {
          form.setFieldsValue({
            district_code: null,
            town_code: null
          })
        }
        if (value.district_code) {
          form.setFieldsValue({
            town_code: null
          })
        }
      }}
    >
      {expanded ? (
        <>
          <div className={styles.formAddFilter}>
            {fields.map((field, index) => (
              <Form.Item
                // labelCol={{ span: 8 }}
                label={field.label}
                name={field.name}
                style={{
                  marginBottom: 8,
                  display: field.hidden == true ? 'none' : 'block'
                }}
                className={styles.formItemFilter}
              >
                {field.type === 'select' ? (
                  <Select
                    style={{ width: '100%' }}
                    placeholder={`Chọn ${field.label}`}
                    onChange={field.onChange}
                    showSearch={true}
                    allowClear={true}
                    filterOption={(input, option) => {
                      const inputValue = removeVietnameseTones(input).toLowerCase();
                      const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                      return optionValue.includes(inputValue);
                    }}
                  >
                    {field.arr && field.arr.length > 0 ? (
                      field.arr.map((item, idx) => (
                        <Option key={idx} value={item.value}>
                          {item.label}
                        </Option>
                      ))
                    ) : (
                      <>
                        {/* <Option value="option1">Option 1</Option>
                        <Option value="option2">Option 2</Option> */}
                      </>
                    )}
                  </Select>
                ) : (field.name == 'acreage' ||
                  field.name == 'area_outside') ? (
                  <InputNumber
                    onBlur={(e) => {
                      const value = parseFloat(e.target.value?.trim())
                      form.setFields([
                        {
                          name: field.name,
                          value: isNaN(value) ? 0 : value
                        }
                      ])
                    }}
                    className={styles.InputNumber}
                    formatter={(value) =>
                      value ? value.replace(/[^0-9.]/g, '') : ''
                    }
                    parser={(value) => value.replace(/[^0-9.]/g, '.')}
                    placeholder="Nhập diện tích"
                  />
                ) : (
                  <Input
                    placeholder={`Nhập ${field.label.toLowerCase()}`}
                    onBlur={(e) => {
                      form.setFields([
                        {
                          name: field.name,
                          value: e.target.value?.trim()
                        }
                      ])
                    }}
                  />
                )
                // <Input placeholder={`Nhập ${field.label}`} />
              }
              </Form.Item>
            ))}
            <Form.Item label="" name="" className={styles.formItemFilter}></Form.Item>
            <div
              className={styles.formItemFilter}
              style={{ textAlign: 'right', marginBottom: 8}}
            >
              <Button onClick={handleReset}>Đặt lại</Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: '0 8px' }}
              >
                Tìm kiếm
              </Button>
              <span
                className="d-flex"
                style={{ color: '#08c', cursor: 'pointer' }}
                onClick={() => setExpanded(!expanded)}
              >
                Thu nhỏ{' '}
                <UpOutlined style={{ fontSize: '14px', color: '#08c' }} />
              </span>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            // display: 'flex',
            // margin: '-0 8px',
            // justifyContent: 'space-between'
            display: 'flex',
            // margin: '-0 8px',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            // gap: 16,
            alignItems: 'center'
          }}
        >
          <Form.Item label="ID" name="id" className={styles.formItemFilter}>
            <Input
              placeholder="Nhập ID"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'id',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <Form.Item
            label="Tên khách hàng"
            name="customer_name"
            className={styles.formItemFilter}
          >
            <Input
              placeholder="Nhập Tên khách hàng"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'customer_name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <Form.Item
            label="Số điện thoại"
            name="customer_phone_number"
            className={styles.formItemFilter}
          >
            <Input
              placeholder="Nhập số điện thoại"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'customer_phone_number',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <div
            className={styles.formItemFilter}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
            <span
              className="d-flex"
              style={{ color: '#08c', cursor: 'pointer' }}
              onClick={() => setExpanded(!expanded)}
            >
              Mở rộng{' '}
              <DownOutlined style={{ fontSize: '14px', color: '#08c' }} />
            </span>
          </div>
          {/* )} */}
        </div>
      )}
    </Form>
  )
}

export default SearchForm
